export const HOME = {
  hero: "homepage-hero",
  accessCodeInput: "access-code-input",
  accessCodeSubmit: "access-code-submit",
  confidentialCallLink: "confidential-call-link",
  callModal: "confidential-call-modal",
  callModalName: "call-modal-name",
  callModalPhone: "call-modal-phone",
  callModalSubmit: "call-modal-submit",
  callModalClose: "call-modal-close",
  errorMessage: "login-error-message",
  emergentLink: "emergent-link",
};

export const DASHBOARD = {
  container: "dashboard-container",
  propertyGrid: "property-grid",
  logoutBtn: "logout-button",
  languageSwitcher: "language-switcher",
  welcomeText: "welcome-text",
  emptyState: "empty-state",
};

export const PROPERTY = {
  card: "property-card",
  viewBtn: "view-opportunity-btn",
  detailContainer: "property-detail-container",
  heroImage: "property-hero-image",
  inquiryBtn: "inquiry-button",
  inquiryModal: "inquiry-modal",
  inquiryName: "inquiry-modal-name",
  inquiryPhone: "inquiry-modal-phone",
  inquiryMessage: "inquiry-modal-message",
  inquirySubmit: "inquiry-modal-submit",
};

export const ADMIN = {
  loginEmail: "admin-login-email",
  loginPassword: "admin-login-pwd",
  loginSubmit: "admin-login-submit",
  setupEmail: "admin-setup-email",
  setupPassword: "admin-setup-pwd",
  setupSubmit: "admin-setup-submit",
  sidebar: "admin-sidebar",
  sidebarDashboard: "sidebar-dashboard",
  sidebarUsers: "sidebar-users",
  sidebarProperties: "sidebar-properties",
  sidebarLeads: "sidebar-leads",
  sidebarInquiries: "sidebar-inquiries",
  sidebarAccessCodes: "sidebar-access-codes",
  sidebarCategories: "sidebar-categories",
  sidebarActivity: "sidebar-activity",
  sidebarAdmins: "sidebar-admins",
  logoutBtn: "admin-logout-btn",
  statsActiveUsers: "stats-active-users",
  statsProperties: "stats-properties",
  statsNewLeads: "stats-new-leads",
  statsNewInquiries: "stats-new-inquiries",
};
